import { z } from 'zod';
import { createToolSignature } from './tool-signature';

export const createPlaybookToolSignature = createToolSignature({
    name: 'createPlaybook',
    description: 'Create a new playbook',
    inputSchema: z.object({
        name: z.string().describe('The name of the playbook'),
        targetGroup: z.string().describe('A description of the type of contacts this playbook is targeting'),
        languages: z
            .array(z.string())
            .describe('The languages that the user communicates in of the playbook (e.g. English, Spanish, etc.)'),
        context: z
            .string()
            .describe(
                'Any additional context that is needed in the context of achieving the purpose (e.g. booking links, product information, etc). Any information or detailed description of how to be successful with the playbook.',
            ),
        purpose: z.string().describe('The purpose or goal of the playbook'),
    }),
    outputSchema: z.object({
        groupId: z.string(),
        assistantSettingsId: z.string(),
    }),
    toolCallUi: (input) => `Creating playbook: ${input.name}`,
});
